import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { AudioLines, Loader2, Square } from 'lucide-react';
import { useManagedSpeech } from '../../hooks/useManagedSpeech';
import { SpeechPlayer } from './SpeechPlayer';
import '../../styles/managed-speech.css';

export const AriaDockSpeech = () => {
  const speech = useManagedSpeech();
  const [expanded, setExpanded] = useState(false);
  const target = document.getElementById('aria-dock-speech-controls');
  const { stop } = speech;
  useEffect(() => {
    const toggle = document.getElementById('aria-chat-toggle');
    const fallback = document.querySelector('[data-testid="aria-dock-static-speech-link"]');
    if (fallback) fallback.hidden = true;
    const onChange = () => { if (!toggle.checked) { stop(); setExpanded(false); } };
    toggle?.addEventListener('change', onChange);
    return () => {
      toggle?.removeEventListener('change', onChange);
      if (fallback) fallback.hidden = false;
    };
  }, [stop]);
  if (!target) return null;
  const readReply = () => {
    const replies = document.querySelectorAll('#aria-dock-messages .dock-msg:not(.dock-msg-user)');
    const text = replies[replies.length - 1]?.textContent || '';
    setExpanded(true);
    speech.generate(text);
  };
  const busy = speech.status === 'generating';
  return createPortal(<div className="managed-speech speech-dock" data-testid="aria-managed-speech">
    <div className="speech-dock-actions">
      <button type="button" data-testid="aria-dock-read-reply" onClick={readReply} disabled={busy}>
        {busy ? <Loader2 size={14} className="animate-spin" /> : <AudioLines size={14} />} {busy ? 'Generating…' : 'Read reply'}
      </button>
      {(busy || (expanded && speech.result)) && <button type="button" data-testid="aria-dock-speech-stop" onClick={stop} title="Stop speech" aria-label="Stop speech"><Square size={14} /></button>}
      <a href="/speech" data-testid="aria-dock-speech-settings">Voice settings</a>
    </div>
    <small data-testid="aria-dock-speech-disclosure">AI-generated · Universal Key credits</small>
    {expanded && <SpeechPlayer speech={speech} testId="aria-dock-speech" />}
    {expanded && speech.error && <p role="alert" className="speech-error" data-testid="aria-dock-speech-error">{speech.error}</p>}
  </div>, target);
};